import { radii } from './borders';
import { breakpoints } from './breakpoints';
import { colors } from './colors';
import { componentStyles } from './componentStyles';
import { shadows } from './shadows';
import { space } from './space';
import { fonts, fontSizes, fontWeights, letterSpacings, lineHeights } from './typography';
import { zIndices } from './zIndices';

export const system = {
  breakpoints,
  space,
  fontSizes,
  colors,
  fonts,
  fontWeights,
  lineHeights,
  letterSpacings,
  radii,
  shadows,
  zIndices,
  componentStyles,
};
